export const UPLOAD_FILE_SIZE_LIMIT_IMAGE = 1024 * 1024 * 10; //10mb
export const UPLOAD_FILE_SIZE_LIMIT_ATN = 1024 * 1024; //1mb
export const NUM_UPLOAD_TEMP_ASSET = 3;
export const TIMEOUT_TOAST_SUCCESS = 2000;
export const TIMEOUT_TOAST_FAIL = 0;
export const TIMEOUT_TOAST_WARNING = 0;
export const STATUS_CODE_SUCCESS_CREATED = 201;
export const STATUS_CODE_SUCCESS_OK = 200;
export const STATUS_CODE_FAIL_LEGAL = 451;
export const STATUS_CODE_FAIL_NOT_FOUND = 404;
export const STATUS_CODE_FAIL_CONFLICT = 409;
export const STATUS_CODE_FAIL_FORBIDDEN = 403;
export const STATUS_CODE_FAIL_UNAUTHORIZED = 401;
export const STATUS_CODE_FAIL_BAD_REQUEST = 400;
export const DEFAULT_DOC_WIDTH = 802;
export const DEFAULT_DOC_HEIGHT = 528;
export const CONSOLE_PROJECT_NAME_PATTERN =
    /^[A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]+(\s[A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]+)*$/;
export const MAX_STRING_LENGTH = 100;
export const MAX_STRING_LENGTH_LONG = 2000;